export default __webpack_public_path__ + "static/media/forgot_password_4.9765846f.svg";